export enum RegistrationViewType {
  CARD = 'card',
  GRID = 'grid',
  FULL_DAY = 'full-day',
  SWIPE = 'swipe',
}
